import { useStoreActions, useStoreState } from 'hooks/useStore'
import { ComponentType, useEffect, useRef, useState } from 'react'
import { useIntersection, useWindowScroll } from 'react-use'
import { Button } from 'reactstrap'
import styled from 'styled-components'
import { Lead } from 'views/property/lead'
import { AgentBar } from './agent-bar'
import { Phone } from './phone'
import { Share } from './share'
import { Whats } from './whats'

const Image = styled.img`
  object-fit: cover;
`
const Wrapper = styled.div`
  border-radius: 5px;
  padding: 40px;
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0 0 0 16px rgba(255, 255, 255, 0.5);
  display: flex;
  flex-direction: column;
  align-items: center
`

interface Props {
  agent: any
  name: string
  principalNotes: string
  uuid: string
  beforeOnShareClick: () => Promise<void>
  shareUrl: string
}

export const AgentDesktop: ComponentType<Props> = ({ agent, name, principalNotes, uuid, beforeOnShareClick, shareUrl }) => {
  const [showBar, setShowBar] = useState(false)
  const ref = useRef(null)
  const invader = useStoreState((state) => state.ui.invader)
  const setInvader = useStoreActions((actions) => actions.ui.setInvader)
  const { y } = useWindowScroll()

  const intersection = useIntersection(ref, {
    rootMargin: '-70px 0px 0px 0px',
    threshold: 0.5,
  })

  useEffect(() => {
    if (y > 520 && intersection) {
      setShowBar(!intersection.isIntersecting)
    }
  }, [intersection, y])

  const onMoreInformationClick = () => {
    beforeOnShareClick()
    setInvader('lead')
  }
  return (
    <>
      {invader === 'lead' && <Lead agent={agent} uuid={uuid} />}
      <AgentBar agent={agent} name={name} principalNotes={principalNotes} beforeOnShareClick={beforeOnShareClick} isPresent={showBar && invader !== 'lead'} shareUrl={shareUrl} />
      <Wrapper ref={ref}>
        <Image src={agent.avatar.thumbnailUrl} alt="Agent profile photo" className="mb-25 w-150px h-150px mx-auto rounded-circle" />
        <h6 className="mb-8 text-center">
          {agent.firstName} {agent.lastName}
        </h6>
        {agent.isCertified && <h6 className="mb-23 font-size-12 text-uppercase font-weight-bold text-center text-certificate-orange">Asesor Certificado</h6>}
        <Button color="primary" className="mb-20" onClick={() => onMoreInformationClick()} block>
          Solicitar más información
        </Button>
        <ul className="px-15 list-unstyled">
          <li className="py-6">
            <Phone phone1={agent.phone1} />
          </li>
          <li className="py-6">
            <Whats whatsapp={agent.whatsapp} shareUrl={shareUrl} beforeOnShareClick={beforeOnShareClick} />
          </li>
          <li className="py-6">
            <Share subject={name} body={principalNotes} beforeOnShareClick={beforeOnShareClick} shareUrl={shareUrl} />
          </li>
        </ul>
        <p className="p-0 text-center text-primary fs-6 text">
          <small>Si eres una agencia externa por favor contacta al 9999441214 para coordinar una cita</small>
          <br />
          <small>Trabajamos únicamente con agencias establecidas y afiliadas a AMPI</small>
        </p>
      </Wrapper>
    </>
  )
}
